import { topSidePartOfWeb } from './parts/sideParts'

export const type3Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()

  ctx.stroke()
  ctx.closePath()
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(240, 274) // 左上
  ctx.quadraticCurveTo(280, 190, 303, 211) //
  ctx.quadraticCurveTo(311, 230, 295, 258) //
  ctx.quadraticCurveTo(296, 226, 285, 230) // 上_内
  ctx.quadraticCurveTo(265, 258, 263, 305) // 左上＿下
  ctx.moveTo(327, 128) // 右上
  ctx.quadraticCurveTo(334, 163, 333, 195) //
  ctx.quadraticCurveTo(326, 179, 323, 177) //
  ctx.quadraticCurveTo(329, 205, 326, 237) //
  ctx.quadraticCurveTo(294, 273, 281, 275) //
  ctx.quadraticCurveTo(269, 293, 269, 293) //
  ctx.quadraticCurveTo(270, 309, 270, 309) //
  ctx.quadraticCurveTo(286, 304, 286, 304) //
  ctx.quadraticCurveTo(291, 286, 320, 272) //
  ctx.quadraticCurveTo(314, 291, 298, 308) //
  ctx.quadraticCurveTo(324, 295, 333, 267) //
  ctx.quadraticCurveTo(341, 262, 341, 262) //
  ctx.quadraticCurveTo(341, 248, 341, 248) //
  ctx.quadraticCurveTo(349, 220, 362, 217) //
  ctx.quadraticCurveTo(359, 194, 359, 194) //
  ctx.quadraticCurveTo(348, 199, 348, 199) //
  ctx.quadraticCurveTo(350, 204, 344, 209) //
  ctx.quadraticCurveTo(340, 149, 326, 126) //
  ctx.moveTo(358, 147) // 右上
  ctx.quadraticCurveTo(346, 172, 346, 172) //
  ctx.quadraticCurveTo(371, 180, 364, 231) //
  ctx.quadraticCurveTo(354, 270, 315, 307) //
  ctx.quadraticCurveTo(340, 300, 357, 276) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}
